import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import {
  ENVIRONMENT,
  EnvironmentModel,
} from '@lyceo/homi/shared/util-environment';
import { PersonIdDto } from './+state/user/user.dto';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private readonly http: HttpClient = inject(HttpClient);
  private readonly environment: EnvironmentModel =
    inject<EnvironmentModel>(ENVIRONMENT);

  public getPersonId(): Observable<PersonIdDto> {
    const url: string = `${this.environment.homiApiUrl}/api/persons/me`;
    const headersToSend: HttpHeaders = new HttpHeaders().set(
      'Accept',
      'application/json',
    );
    return this.http.get<PersonIdDto>(url, {
      headers: headersToSend,
    });
  }
}
